import { useEffect } from "react";
import { useLocation, matchRoutes } from "react-router-dom";
import appRoutes from "routes";
import { useSelector } from "react-redux";
import Clarity from "@microsoft/clarity";
import { FEATURE_FLAGS } from "config/feature-flags";
import { getUser } from "store/selector";
import { getPersonalInfo } from "view/profile/store/selector";
import { trackPageView, identifyUser } from "utils/analytics";

const AnalyticsTracker = () => {
  const location = useLocation();
  const { userId, username } = useSelector(getUser);
  const personalInfo = useSelector(getPersonalInfo);

  useEffect(() => {
    // Initialize Clarity
    if (
      FEATURE_FLAGS.ENABLE_CLARITY &&
      process.env.REACT_APP_CLARITY_PROJECT_ID
    ) {
      Clarity.init(process.env.REACT_APP_CLARITY_PROJECT_ID);
    }
  }, []);

  useEffect(() => {
    if (userId) {
      const userProps = { username };
      if (personalInfo?.iAm) {
        userProps.gender = personalInfo.iAm;
      }
      identifyUser(userId, userProps);

      // Identify user in Clarity
      if (FEATURE_FLAGS.ENABLE_CLARITY) {
        Clarity.identify(userId, null, null, username);
      }
      // Note: identify signature is (customId, customSessionId, customPageId, friendlyName)
      // I am mapping userId -> customId and username -> friendlyName
    }
  }, [userId, username, personalInfo?.iAm]);

  useEffect(() => {
    // Determine title and screen name dynamically from the route config
    const getPageDetails = (pathname) => {
      const allRoutes = Object.values(appRoutes).flat();
      const matches = matchRoutes(allRoutes, pathname);

      // If a route matched, extract the title and screen properties
      if (matches && matches.length > 0) {
        // Typically the matched route we care about is the last one in the matches array
        const matchedRoute = matches[matches.length - 1].route;
        if (matchedRoute.title && matchedRoute.screen) {
          return {
            title: matchedRoute.title,
            screen: matchedRoute.screen,
          };
        }
      }

      // Fallback
      return {
        title: document.title || "Kalyanawaran - Matrimonial Service",
        screen: pathname,
      };
    };

    // Track Page View with a small delay to let Helmet set document.title fallbacks if needed
    setTimeout(() => {
      const details = getPageDetails(location.pathname);
      trackPageView(
        location.pathname + location.search,
        details.title,
        details.screen
      );
    }, 100);
  }, [location]);

  return null;
};

export default AnalyticsTracker;
